export default {
  name: "Sol",
  favicon: `${process.env.REACT_APP_AZURE_STORAGE}/sol/logo.webp`,
  logo: `${process.env.REACT_APP_AZURE_STORAGE}/sol/logo.webp`,
  logoColor: `${process.env.REACT_APP_AZURE_STORAGE}/sol/logo-color.webp`,
  products: [
    {
      id: "lager",
      image: {
        en: `${process.env.REACT_APP_AZURE_STORAGE}/sol/en/product_forward_sol.webp`,
        fr: `${process.env.REACT_APP_AZURE_STORAGE}/sol/fr/product_forward_sol.webp`,
      },
      name: {
        en: "Lager",
        fr: "Lager",
      },
      description: {
        en: "Born in the heart of Mexico in 1899, Sol is a Bright and Refreshing Lager. Inspired by the sun and brewed to shine just like those who drink it.",
        fr: "Née au cœur du Mexique en 1899, la Sol est une lager ensoleillée et rafraîchissante. Inspirée par le soleil et brassée pour briller comme ceux qui la savourent.",
      },
      formats: [
        {
          image: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/sol/en/information_render_can_355ml_sol.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/sol/fr/information_render_can_355ml_sol.webp`,
          },
          details: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/sol/en/information_nft_allrenders_sol.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/sol/fr/information_nft_allrenders_sol_fr.webp`,
          },
          name: {
            en: "Can 355ml",
            fr: "Canette 355ml",
          },
        },
        {
          image: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/sol/en/information_render_can_473ml_sol.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/sol/fr/information_render_can_473ml_sol.webp`,
          },
          details: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/sol/en/information_nft_allrenders_sol.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/sol/fr/information_nft_allrenders_sol_fr.webp`,
          },
          name: {
            en: "Can 473ml",
            fr: "Canette 473ml",
          },
        },
        {
          image: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/sol/en/information_render_bottle_250ml_sol.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/sol/fr/information_render_bottle_250ml_sol.webp`,
          },
          details: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/sol/en/information_nft_allrenders_sol.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/sol/fr/information_nft_allrenders_sol_fr.webp`,
          },
          name: {
            en: "Bottle 330ml",
            fr: "Bouteille 330ml",
          },
        },
      ],
    },
  ],
};
